<template>
  <div>
    <payment-form
      payment-list="/api/payment/list/archive"
      @close="$router.push('/client/payment/list')"
      @list="$router.push('/client/payment/list/archive')"
      @view="id=> $router.push('/client/payment/archive/view?id=' + id)"
    />
  </div>
</template>

<script>
export default {
  props: ['create', 'change', 'view'],
  data: () => ({

  }),
  computed: {

  },
  watch: {

  },
  methods: {

  },
}
</script>
